import React from "react";
import { useAppText } from "src/commun/composants/AppText";
import styles from "./AppInformation.scss";
import parse from "html-react-parser";

const AppInformation = ({ titre = "global.information", texte }: { titre?: string; texte: string }) => {
  const { t, tString } = useAppText();

  return (
    <div className={styles.information}>
      <p className={styles.informationTitre}>{t(titre)}</p>
      <p>{parse(tString(texte))}</p>
      <div className={styles.informationBandeau}/>
    </div>
  );
};

export default AppInformation;
